$(document).ready(function(){

    // scroll button
    $('.scroll-btn').on('click', function(e) {
        e.preventDefault();
        goToAnchor($(this));
    });

    var bar = $('.bar').hasClass('bar-mobile') ? 0 : $('.bar').outerHeight();
    function goToAnchor(link) {
        var toId = link.attr('href').replace('#',''),
            scroll = $('[id="'+toId+'"]').offset().top - $('.rheader').outerHeight() - bar;
        $('html,body').animate({scrollTop: scroll}, 'slow');
    }

});